import { View, Text } from 'react-native'
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons'
import { useTranslation } from 'react-i18next'
import { RANK_COLORS } from '../lib/rankColors'
import { fonts } from '../lib/theme'
import { useThemeColors } from '../lib/useThemeColors'

// Posizione in classifica: medaglia vettoriale (oro, argento, bronzo) per i primi tre, numero per gli altri.
export default function RankBadge({ pos, size = 18, style }) {
  const tc = useThemeColors()
  const { t } = useTranslation()
  const label = t('leagues.position_a11y', { pos })
  if (pos >= 1 && pos <= 3) {
    return (
      <View style={[{ minWidth: 28, alignItems: 'center' }, style]} accessible accessibilityLabel={label}>
        <MaterialCommunityIcons name="medal" size={size + 4} color={RANK_COLORS[pos]} />
      </View>
    )
  }
  return (
    <Text style={[{ minWidth: 28, textAlign: 'center', fontSize: size - 4, fontFamily: fonts.condensedBold, color: tc.textMuted }, style]} accessibilityLabel={label}>
      {pos}°
    </Text>
  )
}
